import SelectDishes from './SelectDishes'
export default SelectDishes
